import { IntlShape } from "react-intl";
import { Column } from "react-table";
import moment from "moment";

import { IMPORT_STATUS } from "api/models";
import { renderFileStatus } from "helpers/fileImportHelpers";

const getFileImportColumns = (intl: IntlShape): Column[] => [
  {
    Header: intl.formatMessage({
      id: "general.date",
      defaultMessage: "Date",
    }),
    id: "date",
    accessor: "file_import_job.created",
    sortable: true,
    Cell: ({ value }: any) => (
      <div className="font-weight-bold">{moment(value, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY HH:mm")}</div>
    ),
  },
  {
    Header: intl.formatMessage({
      id: "general.type",
      defaultMessage: "Type",
    }),
    id: "type",
    accessor: "file_import_job.data_type",
    sortable: true,
    Cell: ({ value }: any) => <div className="text-capitalize">{value || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "general.description",
      defaultMessage: "Description",
    }),
    id: "description",
    accessor: "file_import_job.description",
    sortable: true,
    Cell: ({ value }: any) => <div>{value || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "settings.fileImportTools.fileImportHistory.successUploaded",
      defaultMessage: "Success / Uploaded",
    }),
    id: "total_successful_rows",
    accessor: "total_successful_rows",
    sortable: true,
    Cell: ({ value }: any) => <div>{(value ?? 0).toLocaleString()}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "general.error",
      defaultMessage: "Error",
    }),
    id: "error",
    accessor: "latest_import_job_action.total_failed_rows",
    sortable: true,
    Cell: ({ value }: any) => <div>{(value ?? 0).toLocaleString()}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "general.status",
      defaultMessage: "Status",
    }),
    id: "status",
    accessor: "latest_import_job_action.status",
    sortable: true,
    Cell: ({ value }: { value: IMPORT_STATUS }) => renderFileStatus(value, intl),
  },
  {
    Header: intl.formatMessage({
      id: "general.createdBy",
      defaultMessage: "Created by",
    }),
    id: "created_by",
    accessor: "file_import_job.created_by",
    sortable: true,
    Cell: ({ value }: any) => <div>{value || "-"}</div>,
  },
];

export default getFileImportColumns;
